import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useBlogStore } from "../../store/blogStore.js";
import { useOthersStore } from "../../store/othersStore.js";
import { Input, Select, message, DatePicker, Switch } from "antd";
import dayjs from "dayjs";

import CloudEditor from "../../components/editor/editor-cdn";


import Uploadfile from "../../components/uploadfile/uploadfile";
import Loader from "../../components/loader/loader";
import { PrimaryButton, VioletButtonLarge } from "../../components/button";

const { TextArea } = Input;

const BlogDetails = () => {
  const location = useLocation();
  const { blog, isBlogLoading, getBlog, updateBlog, getBlogs } = useBlogStore();
  const {
    authors,
    isAuthorLoading,
    isCategoryLoading,
    categories,
    getAuthors: fetchAuthors,
  } = useOthersStore();

  const id = location?.pathname?.split("/")[2];

  const [state, setState] = useState({
    slug: "",
    title: "",
    metaTitle: "",
    metaDescription: "",
    featuredImage: "",
    featuredImageAlt: "",
    content: "",
    category: [],
    type: "",
    publishDate: "",
    author: null,
    status: null,
  });

  const [authorsFiltered, setAuthorsFiltered] = useState([]);
  const [categoriesFiltered, setCategoriesFiltered] = useState([]);

  useEffect(() => {
    fetchAuthors();
  }, [fetchAuthors]);

  useEffect(() => {
    const filterAuthors = authors.map((item) => ({
      value: item?.displayName,
      label: item.displayName,
    }));
    setAuthorsFiltered(filterAuthors);
    const filterCategories = categories.map((item) => ({
      value: item?.name,
      label: item.name,
    }));
    setCategoriesFiltered(filterCategories);
  }, [authors, categories]);

  useEffect(() => {
    fetchBlog();
  }, [id]);

  useEffect(() => {
    setState({
      slug: blog?.slug,
      title: blog?.title,
      metaTitle: blog?.metaTitle,
      metaDescription: blog?.metaDescription,
      featuredImage: blog?.featuredImage,
      featuredImageAlt: blog?.featuredImageAlt,
      content: blog?.content,
      category: blog?.category ? blog?.category?.split(",") : [],
      publishDate: blog?.publishDate,
      type: blog?.type,
      author: blog?.author,
      status: blog?.status,
    });
  }, [blog]);

  const fetchBlog = async () => {
    getBlog({ id });
  };

  const handleEditorChange = (content) => {
    setState((prev) => ({
      ...prev,
      content: content,
    }));
  };

  const handleSubmit = () => {
    if (!state?.status) {
      message.error("Status is required");
      return;
    }
    if (state?.status !== "draft") {
      const requiredFields = [
        state?.slug,
        state?.title,
        state?.metaTitle,
        state?.metaDescription,
        state?.featuredImage,
        state?.content,
        state?.category,
        state?.author,
        state?.status,
      ];

      const isValid = requiredFields.every(
        (field) =>
          field &&
          (typeof field === "string" ? field.trim() !== "" : field.length > 0)
      );

      if (!isValid) {
        message.error("Please fill all the required fields");
        return;
      }
    }

    const removeEmptyFields = (obj) => {
      return Object.entries(obj)
        .filter(
          ([_, value]) => value !== "" && value !== null && value !== undefined
        )
        .reduce(
          (acc, [key, value]) => ({
            ...acc,
            [key]:
              typeof value === "object" && !Array.isArray(value)
                ? removeEmptyFields(value)
                : value,
          }),
          {}
        );
    };

    const cleanedState = removeEmptyFields(state);

    const payload = {
      id: id,
      data: {
        ...cleanedState,
        category: Array.isArray(state.category)
          ? state.category.join(", ")
          : state.category,
      },
    };

    updateBlog(payload, (res) => {
      if (res.status === 200) {
        getBlogs({});
      }
    });
  };

  return isBlogLoading || isCategoryLoading || isAuthorLoading ? (
    <Loader />
  ) : (
    <div className="px-3 py-4 flex flex-col gap-5">
      <Uploadfile />
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div className="flex gap-2 items-center">
            Slug *{" "}
            <Link
              to={`https://noblemarriage.com/blog/${state?.slug}`}
              className="px-2 py-1 rounded-lg bg-basePrimary text-white"
              target="_blank"
            >
              Visit
            </Link>
          </div>
          <div className="flex gap-1 items-center">
            <span className="text-[14px] text-gray-500">
              noblemarriage.com/blog/
            </span>
            <Input
              style={{ height: 48 }}
              className="moneyPage"
              placeholder="Blog URL"
              onChange={(e) => setState({ ...state, slug: e.target.value })}
              value={state.slug}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div>Blog Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Blog Title"
            onChange={(e) => setState({ ...state, title: e.target.value })}
            value={state.title}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Meta Title *</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Meta Title"
            onChange={(e) => setState({ ...state, metaTitle: e.target.value })}
            value={state.metaTitle}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Meta Description *</div>

          <TextArea
            rows={4}
            className="moneyPage"
            placeholder="Meta Description"
            onChange={(e) =>
              setState({ ...state, metaDescription: e.target.value })
            }
            value={state.metaDescription}
          />
        </div>

        <div className="flex flex-col gap-2">
          <div>Featured Image *</div>

          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Featured images"
            onChange={(e) =>
              setState({ ...state, featuredImage: e.target.value })
            }
            value={state.featuredImage}
          />
          {state.featuredImage && (
            <img
              src={state?.featuredImage}
              className="h-[150px] w-max"
              alt="featured"
            />
          )}
        </div>
        <div className="flex flex-col gap-2">
          <div>Featured Image Alt</div>
          <Input
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Featured image alt"
            onChange={(e) =>
              setState({ ...state, featuredImageAlt: e.target.value })
            }
            value={state.featuredImageAlt}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div>Content *</div>
          <div className="bg-white border border-gray-300 rounded-lg p-2">
            <CloudEditor data={state?.content} onChange={handleEditorChange} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div>Category *</div>
          <Select
            className="moneyPage"
            showSearch
            placeholder="Select"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={categoriesFiltered}
            value={state?.category}
            mode="multiple"
            onChange={(e) => {
              setState({
                ...state,
                category: e,
              });
            }}
          />
        </div>
        <div className="flex gap-2 items-center  pt-5">
          <div>Featured *</div>
          <Switch
            onChange={(e) => setState({ ...state, type: e ? "featured" : "" })}
          />
        </div>
        <div className="flex flex-col gap-2 pt-5">
          <div>Date Published *</div>
          <DatePicker
            style={{ height: 48 }}
            className="moneyPage"
            placeholder="Date Published"
            onChange={(date, dateString) => {
              setState({
                ...state,
                publishDate: dateString,
              });
            }}
            value={
              state.publishDate ? dayjs(state.publishDate, "YYYY-MM-DD") : null
            }
          />
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <div>Author *</div>

        <Select
          style={{ height: 48 }}
          className="moneyPage"
          showSearch
          placeholder="Select"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={authorsFiltered}
          value={state?.author}
          onChange={(e) => {
            setState({
              ...state,
              author: e,
            });
          }}
        />
      </div>
      <div className="flex flex-col gap-2">
        <div>Want to Publish? *</div>

        <Select
          style={{ height: 48, width: 200 }}
          className="moneyPage"
          showSearch
          placeholder="Select"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={[
            {
              value: "publish",
              label: "Published",
            },
            {
              value: "draft",
              label: "Draft",
            },
          ]}
          value={state?.status}
          onChange={(e) =>
            setState({
              ...state,
              status: e,
            })
          }
        />
      </div>
      <div className="flex gap-3 items-center">
        <PrimaryButton
          text="Save"
          style={{ width: "200px" }}
          onClick={handleSubmit}
        />
        <VioletButtonLarge
          text="Cancel"
          style={{ width: "200px" }}
          onClick={() => window.history.back()}
        />
      </div>
    </div>
  );
};

export default BlogDetails;








